import { Input as ChakraInput, InputProps } from "@chakra-ui/react";
import { makeFormInputDefaultProps } from "../common/styles";
const Input = (props: InputProps) => {
  return (
    <ChakraInput
      {...makeFormInputDefaultProps(props?.focusBorderColor)}
      {...props}
    />
  );
};

export { Input };
